import { combineReducers } from "redux";

import {
    NovelGalleryAction,
    NovelGalleryActionActionType,
} from "@customer-gallery/redux/galleryTypedRedux";
import {
    ICryptoAddressesReducerState,
    walletsReducer,
} from "@customer-gallery/redux/reducers/cryptoAddresses";
import {
    discountsReducer,
    IDiscountReducerState,
} from "@customer-gallery/redux/reducers/discounts";
import {
    IUnclaimedTokensReducerState,
    unclaimedTokensReducer,
} from "@customer-gallery/redux/reducers/unclaimedTokens";

import { authReducer, IAuthReducerState } from "./auth";

const reducersObj = {
    auth: authReducer,
    addresses: walletsReducer,
    unclaimedTokens: unclaimedTokensReducer,
    discounts: discountsReducer,
};

// object ref ensures equality check failure
const impossibleToEqual = {};

// default values for each reducer
export const initialState: INovelState = Object.keys(reducersObj).reduce(
    (accum: any, key: string) => {
        accum[key] = (reducersObj as any)[key](void 0, {
            type: impossibleToEqual,
        });
        return accum;
    },
    {},
) as any;

export const rootReducer = combineReducers<
    INovelState,
    NovelGalleryAction<NovelGalleryActionActionType>
>(reducersObj);

export interface INovelState {
    auth: IAuthReducerState;
    addresses: ICryptoAddressesReducerState;
    unclaimedTokens: IUnclaimedTokensReducerState;
    discounts: IDiscountReducerState;
}
